import {Component, Fragment} from "react";
import * as React from "react";
import {IconButton, TextField} from "office-ui-fabric-react";

export interface EditableCardProps<T>
{
    item: T;
    namePropertyName: string;
    onRename(yearGrouping: T,newName: string): void
    onDelete(yearGrouping: T): void;
}

interface EditableCardState<T>
{
    renaming: boolean;
    currentName: string;
    newName: string;
}

export default class EditableCard<T extends {[key: string]: string}> extends Component<EditableCardProps<T>,EditableCardState<T>>
{

    constructor(props: Readonly<EditableCardProps<T>>) {
        super(props);
        
        const currentName = props.item[props.namePropertyName];
        this.state = {
            renaming: currentName === "",
            currentName,
            newName: "",
        };
    }

    public componentDidMount() {
    }

    
    
    public render() {
        
        
        const mainContent = (
            <Fragment>
                <span className={"flex-item--flex-1"}>{this.state.currentName}</span>
                <IconButton iconProps={{iconName: "Edit"}} title="Rename" ariaLabel="Rename" onClick={() => {
                    this.setState({
                        newName: this.state.currentName,
                        renaming: true
                    });
                }}/>
                <IconButton iconProps={{iconName: "Delete"}} title="Delete" ariaLabel="Delete" onClick={() => {
                    this.props.onDelete(this.props.item);
                }}/>
                {this.props.children}
            </Fragment>
        );
        
        const renamingContent = (
            <Fragment>
                <TextField
                    className="flex-item--flex-1 m-right-1rem"
                    disabled={false}
                    value={this.state.newName}
                    onChange={(e,v) => this.setState({
                        newName: v!
                    })}
                    required={false}
                />
                <IconButton iconProps={{iconName: "Cancel"}} title="Cancel Rename" ariaLabel="Cancel Rename" onClick={() => {
                    
                    this.setState({
                        renaming: false,
                        newName: ""
                    });
                }}/>
                <IconButton iconProps={{iconName: "CheckMark"}} title="Complete Rename" ariaLabel="Complete Rename" onClick={() => {
                    
                    this.props.onRename(this.props.item,this.state.newName);
                    this.setState({
                        renaming: false,
                        newName: ""
                    });
                }}/>
            </Fragment>
        );
        

        return (
            <div className={"card card--padded card--margin-small flex-row flex--align-items-center"}>
                {this.state.renaming ? renamingContent : mainContent}
            </div>
        );
    }
}